module.exports = __webpack_public_path__ + "img/2-18.cc4bc4b9.jpg";